import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type JackpotCarouselContainerProps = Omit<ComponentProps<'div'>, 'title'> & {
  title?: string;
};

/**
 * Container for jackpot carousel, with title and children, and aligned styles across all variants.
 * Extends the props of HTMLDivElement.
 * @param namespace - Namespace for translations
 * @returns HTMLDivElement with jackpot carousel expected to be rendered inside it
 */
function JackpotCarouselContainer({ title, className, children, ...props }: JackpotCarouselContainerProps) {
  return (
    <div className={twMerge('ll-container-full flex flex-col items-center', className)} {...props}>
      {title ? <p className="max-w-75 text-center paragraph-strong">{title}</p> : null}
      <div className="w-full">{children}</div>
    </div>
  );
}

export { JackpotCarouselContainer };
